import { Card } from "@brg/api"
// @ts-ignore
import { RootState } from "shared/store/configureStore"

export namespace OrderSelectors {
    export const productFieldsSelector = (state: RootState): Card | any => state.order.productFields
    export const flowStepSelector = (state: RootState): number | any => state.order.flowStep
    export const flowSizeSelector = (state: RootState): number | any => state.order.flowSize
    export const flowTypeSelector = (state: RootState): number | any => state.order.flowType
}import { Card } from "@brg/api"
// @ts-ignore
import { RootState } from "shared/store/configureStore"

export namespace OrderSelectors {
    export const productFieldsSelector = (state: RootState): Card | any => state.order.productFields
    export const flowStepSelector = (state: RootState): number | any => state.order.flowStep
    export const flowSizeSelector = (state: RootState): number | any => state.order.flowSize
    export const flowTypeSelector = (state: RootState): number | any => state.order.flowType
}